import { render } from "./TeamManagement.vue?vue&type=template&id=6b48c723&scoped=true"
import script from "./TeamManagement.vue?vue&type=script&lang=js"
export * from "./TeamManagement.vue?vue&type=script&lang=js"

import "./TeamManagement.vue?vue&type=style&index=0&id=6b48c723&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b48c723"]])

export default __exports__